<template>
  <v-card>
    <template>
      <v-card-title class="i-dialog-header-div">
        <span class="g-heading-m g-bold">{{ title }}</span>
      </v-card-title>

      <v-card-text class="py-4 text-center">
        <p v-html="text"></p>
        <div class="mt-4" v-if="messageNeeded">
          <span>
            <strong>{{ messageTitle }}</strong>
          </span>
          <br />
          <v-text-field
            class="pa-0 mt-6 ma-0 mb-n1"
            dense
            v-model="message"
            label="Message to Supplier"
            outlined
            append-icon="mdi-message-reply-text"
            counter="255"
            maxlength="255"
            required
          ></v-text-field>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn rounded text class="i-btn-text-black" @click="handleClose"
          >Cancel</v-btn
        >
        <v-btn
          rounded
          class="i-btn-block-secondary"
          :loading="submitting"
          :disabled="messageNeeded && !message"
          @click="handleConfirm"
          >{{ $filters.sentenceCase(actionText) }}</v-btn
        >
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    message: null
  }),

  props: {
    actionText: {
      default: 'Confirm',
      type: String
    },

    messageNeeded: {
      default: false,
      type: Boolean
    },

    messageTitle: {
      default: '',
      type: String
    },

    submitting: {
      default: false,
      type: Boolean
    },

    text: {
      required: true,
      type: String
    },

    title: {
      default: 'Confirmation',
      type: String
    }
  },

  methods: {
    handleClose() {
      this.$emit('cancel')
    },

    handleConfirm() {
      this.$emit('confirm', this.message)
      this.message = null
    }
  }
}
</script>
